import { initFlyout } from "./flyout.ts"

initFlyout()
